DP = processData  = require("lib/data-processer")
dataProcessor     = processData.all
metadataProcessor = processData.allMD

Engines =
  'question-pool': Friedrich.QuestionPool
  'scorm':         Friedrich.Scorm
  'video':         Friedrich.Video

class LessonEngine
  constructor: (conf = {}) ->
    @configuration = conf

    @states = conf.userState or {}

    @engines = @createEngines()
    @_interactions = []

  trackInteraction: (i) ->
    Analytics = Application.actions().Analytics
    Analytics.trackInteraction(i)

  createEngines: ->
    slides = @configuration.slides
    slidesWithEngine = slides.filter((s) -> Engines[s.type]?)
    _.object(slidesWithEngine.map (s) =>
      [s.id, new Engines[s.type](s.id, s.name, s.data, @states[s.id])])


  processSlides: (data) =>
    data.slides = _.flatten data.slides.map (s, i) =>
      if s.id and @engines?[s.id]?.renderSlides?
        slides = @engines?[s.id]?.renderSlides()
        slides = slides.map (s) ->
          s.data = DP.one(s.data, s.type, data.config)
          s.metadata = DP.oneMD(s.metadata)
          s.strippedMetadata = DP.oneSMD(s.metadata)
          s
      else
        s

    data.slides = data.slides.map (s, i) ->
    # if next slide is of type exit, then we will avoid showing it
      s.isLastSlide = i is data.slides.length - 1 or (data.slides[i+1]?.type is "exit" and data.config.isQuiz)
      s

    data

  slides: ->
    dataPipe      = [ dataProcessor, metadataProcessor, @processSlides ]
    processedData = _.extend({}, @configuration)
    for fn in dataPipe
      processedData = fn(processedData)
    @_slides = processedData
    return @_slides

  _recordInteractions: (intes = []) ->
    for i in intes
      @_interactions.push(i)
      @trackInteraction(i)

  _publishState: ->
    state = @getState()
    @trackInteraction({ isLessonUserState: true, state: state })

  getState: ->
    _.object(
      [slideId, engine.state] for slideId, engine of @engines when engine.state
    )

  processInteraction: (interaction) ->
    @_recordInteractions([interaction])
    md = interaction.metadata
    if md? and @engines[md.friedrichId]?
      engine = @engines[interaction.metadata.friedrichId]

      if engine.processInteraction?
        intes  = engine.processInteraction(interaction) or []
        @_recordInteractions(intes)

      if engine.reduceState?
        engine.reduceState(interaction)
        @_publishState()


module.exports = LessonEngine
